import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kp-reflect-animation',
  templateUrl: './reflect-animation.component.html',
  styleUrls: ['./reflect-animation.component.scss'],
})
export class ReflectAnimationComponent implements OnInit {
  @Input() skipIntro = false;
  // CSS is set up so the canvas will fill out the width of its containing div.
  // Animation looks the crispest when the canvas resolution matches the canvas size.
  @Input() canvasHeight = 192;
  @Input() canvasWidth = 192;
  @Output() introOver: EventEmitter<boolean> = new EventEmitter();

  playIntro = false;
  playLoop = false;

  @HostBinding('class.use-alternate')
  useAlternate = false;

  ngOnInit() {
    // use generic alternate if no WASM support if no animation provided
    this.useAlternate = typeof WebAssembly !== 'object';

    // setup intro / loop
    this.playIntro = !this.skipIntro;
    this.playLoop = this.skipIntro;
  }

  playChange() {
    this.playIntro = false;
    this.playLoop = true;
    this.introOver.emit();
  }
}
